<template>
	<div  v-loading="loading1" :class="{ 'from-order-new': isFromOrderNew }">
		<el-form  ref="form" :model="form" :inline="true" label-width="120px" style="width: 1000px;" action="http://"
             target="stop" :rules="rules">
			<template  v-if="form.resource != 3">
				<p>接收信息</p>
				<el-form-item label="电子邮箱"><el-input v-model="form.email" placeholder="xxx@xxx.com"></el-input></el-form-item>
			</template>
      <template v-if="form.resource == 3">
        <p>接收信息</p>
        <el-form-item label="接收地址:" style="margin-left: 40px;">
          <el-input v-model="form.contactAddr" style="color: #fea100;width: 217px;" placeholder="请输入接收地址"></el-input>
        </el-form-item>
        <el-form-item label="联系人:" style="margin-left: 40px;">
          <el-input v-model="form.contactName" style="color: #fea100;width: 217px;" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱"><el-input v-model="form.email" placeholder="xxx@xxx.com"></el-input></el-form-item>
        <el-form-item label="联系电话:" style="margin-left: 40px;">
          <el-input v-model="form.contactMobile" style="color: #fea100;width: 217px;" placeholder="请输入联系人电话"></el-input>
        </el-form-item>
      </template>
			<p>发票信息<small class="red">（大救星清单开具的发票项目名称为“救援服务费”，大救星急救包开具的发票项目名称为“日用杂品*急救包”。  电子普票可实时自动开具，专票将在15个工作日内按照您的收件地址邮寄。）</small></p>
			<el-form-item prop="resource" style="width: 900px; ">
				<el-radio-group v-model="form.resource">
					<el-radio label="2">开具企业发票（ 普票 ）</el-radio>
					<el-radio label="3">开具企业发票（ 专票 ）</el-radio>
				</el-radio-group>
			</el-form-item>
      <div class="overflow">
        <p class="left">发票金额：<span class="yellow">￥{{form.money}}元</span></p>
        <div class="right">
          <span>已选择{{getTotalSelectedCount()}}个账单</span>
          <el-button type="primary" size="mini" @click='openBillDialog'>选择账单</el-button>
        </div>
      </div>

			<!-- 个人 -->
			<div class="person" v-if="form.resource == 1">
				<el-form-item   label="发票抬头:">
        
            <el-input type="email" v-model="form.customerName" auto-complete="on" name="username" placeholder="请填写发票抬头"></el-input>   
    
        </el-form-item>
			</div>
			<!-- 企业（普票） -->
			<div class="person" v-if="form.resource == 2">
				<el-form-item label="发票抬头:">
					<el-input v-model="form.customerName" auto-complete="on" name="username"  placeholder="请填写发票抬头"></el-input>
          
					<ul class="inputBox" v-show="loading">
						<li v-if="customerNameList.length != 0" v-for="item in customerNameList" :title="item.EnterpriseName" @click="getShuihao(item)">
							{{ item.EnterpriseName }}
						</li>
						<p style="color: #ccc;text-align: center;font-weight: normal;" v-if="customerNameList.length == 0">未搜索到</p>
					</ul>
				</el-form-item>
				<!-- <el-button class="search" icon="el-icon-search" @click="remoteMethod(form.customerName)"></el-button> -->
				<el-form-item label="纳税人识别号" prop="tin"><el-input v-model="form.tin"></el-input></el-form-item>
			</div>

           <!--stop的iframe阻止submit后跳转-->
    <iframe v-show="false" name="stop" class="none"></iframe>
    <!--stop的iframe阻止submit后跳转 end-->
 
 


			<div class="person" v-if="form.resource == 3">
				<el-form-item label="发票抬头:">
					<el-input v-model="form.customerName" auto-complete="on" name="username" placeholder="请填写发票抬头" clearable></el-input>
					<ul class="inputBox" v-show="loading">
						<li v-if="customerNameList.length != 0" v-for="item in customerNameList" :title="item.EnterpriseName" @click="getShuihao(item)">
							{{ item.EnterpriseName }}
						</li>
						<p style="color: #ccc;text-align: center;font-weight: normal;" v-if="customerNameList.length == 0">未搜索到</p>
					</ul>
				</el-form-item>
				<el-button class="search" icon="el-icon-search" @click="remoteMethod(form.customerName)"></el-button>
				<el-form-item label="纳税人识别号" prop="tin"><el-input v-model="form.tin"></el-input></el-form-item>

				<el-form-item label="发票地址:" style="margin-left: 40px;"><el-input v-model="form.addr" style="color: #fea100;width: 217px;"></el-input></el-form-item>
				<el-form-item label="发票电话:"><el-input v-model="form.phone" style="color: #fea100;width: 217px;"></el-input></el-form-item>
				<el-form-item label="开户银行:" style="margin-left: 56px;"><el-input v-model="form.bankName" style="color: #fea100;width: 217px;"></el-input></el-form-item>
				<el-form-item label="银行账号:"><el-input v-model="form.bankAccount" style="color: #fea100;width: 217px;"></el-input></el-form-item>
			</div>
			<el-form-item label="备注:" style="width: 900px;">
				<el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" maxlength="50" show-word-limit></el-input>
			</el-form-item>
			<el-form-item style="width: 1000px;text-align: center;"><el-button  type="primary" @click="submitForm()">提交申请</el-button></el-form-item>
		</el-form>
    <el-dialog title="订单选择" :visible.sync="centerDialogVisible" width="1200px" center top="1vh" v-loading="dialogLoading" element-loading-text="加载中...">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane v-if="!hideDetailTab" label="子订单" name="detail">
          <el-form :inline="true"  class="demo-form-inline">
            <el-form-item label="时间范围">
              <el-date-picker
                v-model="value1"
                type="daterange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-button class="text2 " type="primary" @click='seeData'>查询</el-button>
          </el-form>
          <div class="table">
            <el-table :data="tableData" style="width: 100%"  height='calc(100vh - 280px)' @selection-change="handleSelectionChange" ref="detailTable">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="detail.id" label="ID" width="80"></el-table-column>
              <el-table-column label="出单时间">
                <template slot-scope="scope">{{ setTime(scope.row.detail.createAt) }}</template>
              </el-table-column>
              <el-table-column label="姓名" prop="detail.name"></el-table-column>
              <el-table-column label="证件号" prop="detail.nationalId"></el-table-column>
              <el-table-column label="商品名称" prop="product.name"></el-table-column>
              <el-table-column label="付款金额">
                <template slot-scope="scope">
                  <span>￥{{scope.row.detail.amount/100}}元</span>
                </template>
              </el-table-column>
              <el-table-column label="订单状态">
                <template slot-scope="scope">
                  <span class="yellow">{{billingState[scope.row.detail.billingState]}}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="fenye">
              <el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="currentPage" :page-sizes="[50, 100, 200, 500]" :page-size="eachPage" layout="total, sizes, prev, pager, next, jumper"
               :total="allpage">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="总订单" name="order">
          <el-form :inline="true"  class="demo-form-inline">
            <el-form-item label="时间范围">
              <el-date-picker
                v-model="value1"
                type="daterange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-button class="text2 " type="primary" @click='seeData'>查询</el-button>
          </el-form>
          <div class="table">
            <el-table :data="orderTableData" style="width: 100%"  height='calc(100vh - 280px)' @selection-change="handleOrderSelectionChange" ref="orderTable">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="bill.id" label="ID" width="80"></el-table-column>
              <el-table-column label="出单时间" width="180">
                <template slot-scope="scope">{{ setTime(scope.row.bill.createAt) }}</template>
              </el-table-column>
              <el-table-column label="订单号" width="160">
                <template slot-scope="scope">
                  <span>{{scope.row.bill.billingNo}}</span>
                </template>
              </el-table-column>
              <el-table-column label="姓名" width="200">
                <template slot-scope="scope">
                  <span v-if="scope.row.detailsname">{{scope.row.detailsname}}</span>
                  <span v-else-if="scope.row.details && scope.row.details.length > 0">
                    <span v-if="scope.row.product.productGroup == 'G67'">{{scope.row.details[0].name}}</span>
                    <span v-else>{{scope.row.details.map(d => d.name).join(',')}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="product.name" width="150"></el-table-column>
              <el-table-column label="数量" prop="detailCount" align="center" width="100"></el-table-column>
              <el-table-column label="付款金额">
                <template slot-scope="scope">
                  <span>￥{{scope.row.bill.realAmount/100}}元</span>
                </template>
              </el-table-column>
              <el-table-column label="订单状态">
                <template slot-scope="scope">
                  <span class="yellow">{{billingState[scope.row.bill.billingState]}}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="fenye">
              <el-pagination class='pagination' @size-change="handleOrderSizeChange" @current-change="handleOrderCurrentChange"
              :current-page.sync="orderCurrentPage" :page-sizes="[50, 100, 200, 500]" :page-size="orderEachPage" layout="total, sizes, prev, pager, next, jumper"
               :total="orderAllpage">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
       <span slot="footer" class="dialog-footer">
          <el-button @click="handleDialogClose">取 消</el-button>
          <el-button type="primary" @click="handleDialogConfirm">确 定</el-button>
        </span>
    </el-dialog>
       <!-- <el-form :model="form" ref="ruleForm"  label-width="100px" class="demo-ruleForm"
             action="http://"
             target="stop">
      <el-row>
        <el-col :span="23">
          <el-form-item label="姓名" :prop="username">
            <el-input v-model="form.username"
                      auto-complete="on"
                      name="username"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="23" class="tr">
          <el-form-item class="no_m">
            <el-button :loading="loading" type="primary" @click="submitForm1">
                提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form> -->
	</div>
</template>

<script>
import axios from 'axios';
import { issue2,ration,listInvoiceBillDetail,listDd } from '@/axios/api.js';
import common from '@/assets/common.js';
export default {
	data() {
		return {
      loading1:false,
      value1: null,
       endts:'',
       startts:'',
       eachPage:'',
       	allpage:0,//数据总数
				eachPage:50,//每页
				indexPage:0,//当前页	
        currentPage:1,		
			form: {
				email: '', //电子邮箱
				resource: '2', //个人or企业
				customerName: '',
				money: '0',
				tin: '',
				time: '2015-1-5', //发票时间
				content: '救援服务费', //发票内容
				addr: '',
				phone: '',
				bankName: '',
				bankAccount: '',
        contactAddr:'',
        contactName:'',
        contactMobile:'',
        remark: ''
			},
			/**
       * 表单校验规则
       */
      rules: {
        tin: [
          {
            validator: this.validateTin,
            trigger: 'blur'
          }
        ]
      },
			customerNameList: [],
			data: [],
			id: '',
			loading: false,
      centerDialogVisible:false,
      tableData:[],
      typeRstatus:['订单' , '分成' , '退单-订单' , '退单-分成'],
      billingState:['创建','线上支付完成','挂帐月结-未付','线下转账-已付款','已退单','投保失败退单'],
      multipleSelection:[],
      activeTab: 'detail', // 当前选中的tab：detail-子订单，order-总订单
      hideDetailTab: false, // 是否隐藏子订单tab
      orderTableData: [], // 总订单列表数据
      orderAllpage: 0, // 总订单数据总数
      orderEachPage: 50, // 总订单每页数量
      orderIndexPage: 0, // 总订单当前页索引
      orderCurrentPage: 1, // 总订单当前页码
      orderMultipleSelection: [], // 总订单选中的数据
      dialogLoading: false, // 弹框内loading状态
      isFromOrderNew: false // 是否从orderNew页面跳转过来
		};
   
	},
	mounted() {
		var time = new Date().getTime();
		this.form.time = common.time(time);
		// 检查是否从订单页面跳转过来
		this.isFromOrderNew = this.$route.query.fromOrderNew === 'true';
		// 获取 channelId
		var channelId = localStorage.getItem("channelId");
		// 检查是否从订单页面跳转过来，或者 channelId 为 2137 或 2753
		if (this.isFromOrderNew || channelId === '2137' || channelId === '2753' || channelId === '2108') {
			this.hideDetailTab = true;
			this.activeTab = 'order'; // 默认选中总订单
		}
	},
	watch: {
		/**
		 * 监听时间范围选择器的变化
		 * 当清空时间筛选时，重新获取数据
		 */
		value1(newVal) {
			// 当时间范围被清空时（变为 null 或空数组）
			if (!newVal || (Array.isArray(newVal) && newVal.length === 0)) {
				this.startts = '';
				this.endts = '';
				// 根据当前选中的 tab 重新获取数据
				if (this.activeTab === 'detail') {
					this.indexPage = 0;
					this.currentPage = 1;
					this.getData();
				} else if (this.activeTab === 'order') {
					this.orderIndexPage = 0;
					this.orderCurrentPage = 1;
					this.getOrderData();
				}
			}
		}
	},
	methods: {
    	handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.getData()
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = (val-1) * this.eachPage;
				console.log(val)
				this.getData()
			},
    seeData() {
      if (this.activeTab === 'detail') {
        // 子订单查询
        if (this.value1 && this.value1.length === 2) {
          this.startts = this.value1[0]
          if(this.value1[0] == this.value1[1]) {
            this.endts = this.value1[1] + 86399000
          }else {
            this.endts = this.value1[1]
          }
        } else {
          this.startts = '';
          this.endts = '';
        }
        this.indexPage = 0
        this.currentPage = 1
        this.getData()
      } else if (this.activeTab === 'order') {
        // 总订单查询
        if (this.value1 && this.value1.length === 2) {
          this.startts = this.value1[0]
          if(this.value1[0] == this.value1[1]) {
            this.endts = this.value1[1] + 86399000
          }else {
            this.endts = this.value1[1]
          }
        } else {
          this.startts = '';
          this.endts = '';
        }
        this.orderIndexPage = 0
        this.orderCurrentPage = 1
        this.getOrderData()
      }
      console.log(this.value1)
    },
    setTime(str) {
    	return common.time(str)
    },
    /**
     * 获取子订单数据
     */
    /**
     * 获取子订单数据
     */
    getData(){
      this.dialogLoading = true;
      var data={
        state:1,
      	start:this.indexPage,
      	count:this.eachPage,
        startts:this.startts,
        endts:this.endts
      }
      listInvoiceBillDetail(data)
      .then(res => {
      	console.log(res)
      	this.tableData=res.data.obj;
        	this.allpage=res.data.total;
        	this.dialogLoading = false;
      })
      .catch(err => {
      	console.log(err)
      	this.dialogLoading = false;
      	var errorMsg = '获取子订单列表失败，请重试！';
      	if(err && err.response && err.response.data && err.response.data.msg){
      		errorMsg = err.response.data.msg;
      	} else if(err && err.message){
      		errorMsg = err.message;
      	}
      	this.$message.error(errorMsg);
      })
    },
    /**
     * 获取总订单数据
     */
    getOrderData(){
      this.dialogLoading = true;
      var data = {
        state:'',
        start: this.orderIndexPage,
        count: this.orderEachPage,
        startts: this.startts,
        endts: this.endts,
        payType: ''
      }
      listDd(data)
      .then(res => {
        console.log(res)
        this.orderTableData = res.data.obj || [];
        // 处理总订单的姓名显示
        for(var i = 0; i < this.orderTableData.length; i++) {
          if(this.orderTableData[i].product.productGroup == 'G67') {
            this.orderTableData[i].detailsname = this.orderTableData[i].details[0].name
          } else {
            var str = ''
            for(var j = 0; j < this.orderTableData[i].details.length; j++) {
              str += this.orderTableData[i].details[j].name + ','
            }
            var str1 = str.substr(0, str.length - 1);
            this.orderTableData[i].detailsname = str1
          }
        }
        this.orderAllpage = res.data.total || 0;
        this.dialogLoading = false;
      })
      .catch(err => {
        console.log(err)
        this.dialogLoading = false;
        var errorMsg = '获取总订单列表失败，请重试！';
        if(err && err.response && err.response.data && err.response.data.msg){
          errorMsg = err.response.data.msg;
        } else if(err && err.message){
          errorMsg = err.message;
        }
        this.$message.error(errorMsg);
      })
    },
    /**
     * Tab切换处理
     */
    handleTabClick(tab) {
      if (tab.name === 'detail') {
        // 切换到子订单，清空总订单选择
        this.orderMultipleSelection = [];
        if (this.$refs.orderTable) {
          this.$refs.orderTable.clearSelection();
        }
        this.indexPage = 0;
        this.currentPage = 1;
        this.getData();
      } else if (tab.name === 'order') {
        // 切换到总订单，清空子订单选择
        this.multipleSelection = [];
        if (this.$refs.detailTable) {
          this.$refs.detailTable.clearSelection();
        }
        this.orderIndexPage = 0;
        this.orderCurrentPage = 1;
        this.getOrderData();
      }
    },
    /**
     * 总订单分页大小改变
     */
    handleOrderSizeChange(val) {
      this.orderEachPage = val;
      this.orderIndexPage = 0;
      this.orderCurrentPage = 1;
      this.getOrderData();
    },
    /**
     * 总订单当前页改变
     */
    handleOrderCurrentChange(val) {
      this.orderIndexPage = (val - 1) * this.orderEachPage;
      this.getOrderData();
    },
    /**
     * 总订单选择变化处理
     */
    handleOrderSelectionChange(val) {
      this.orderMultipleSelection = val;
      // 计算总金额
      var money = 0;
      val.forEach(item => {
        money += Number(item.bill.realAmount);
      });
      // 合并子订单和总订单的选中项来计算总金额
      var totalMoney = money;
      this.multipleSelection.forEach(item => {
        totalMoney += Number(item.detail.amount);
      });
      this.form.money = totalMoney / 100;
    },
       acc(arg1,arg2) {
    var m=0,s1=arg1.toString(),s2=arg2.toString();
    try{m+=s1.split(".")[1].length}catch(e){}
    try{m+=s2.split(".")[1].length}catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
},
		submitForm() {
    
     console.log(this.acc(this.form.money,100))
			var data = {};
			var reg = /[^@]+@[^@]+\.[a-zA-Z]{2,6}/;
      if(this.form.resource != 3){
        if (this.form.email == '') return this.$message.warning('电子邮箱未填写！');
        if (!reg.test(this.form.email)) return this.$message.warning('电子邮箱格式不正确！');
      }

			if (this.form.customerName == '') return this.$message.warning('发票抬头不能为空！');
			if (this.form.money == '') return this.$message.warning('发票金额不能为空！');
			var regNum = /^[0-9]+.?[0-9]*$/;
			if (!regNum.test(this.form.money)) return this.$message.warning('发票金额必须为数字！');

      var billDetailIdLst = ''
      var detailIdArray = []
      
      // 处理子订单选择 - 提取子订单的ID
      if(this.multipleSelection.length != 0){
        this.multipleSelection.forEach((item) => {
          if(item.detail && item.detail.id){
            detailIdArray.push(item.detail.id)
          }
        })
      }
      
      // 处理总订单选择 - 从每个总订单的details数组中提取所有子订单ID
      // 只提取billingState为1、2、3，且invoiceStatus不是1、2的子订单ID
      if(this.orderMultipleSelection.length != 0){
        this.orderMultipleSelection.forEach((orderItem) => {
          // 总订单下的子订单在 details 数组中
          if(orderItem.details && Array.isArray(orderItem.details) && orderItem.details.length > 0){
            orderItem.details.forEach((detailItem) => {
              // 判断billingState和invoiceStatus，只有符合条件才拼接
              if(detailItem && detailItem.id){
                // 检查billingState是否为1、2、3
                var billingStateValid = detailItem.billingState === 1 || detailItem.billingState === 2 || detailItem.billingState === 3;
                // 检查invoiceStatus是否不是1、2（1和2时不拼接，其他时候可以拼接）
                var invoiceStatusValid = detailItem.invoiceStatus !== 1 && detailItem.invoiceStatus !== 2;
                // 同时满足两个条件才拼接
                if(billingStateValid && invoiceStatusValid){
                  detailIdArray.push(detailItem.id)
                }
              }
            })
          }
        })
      }
      
      // 将ID数组拼接成逗号分隔的字符串
      if(detailIdArray.length > 0){
        billDetailIdLst = detailIdArray.join(',')
      }
      
      if(billDetailIdLst === ''){
        return this.$message.warning('请选择账单！');
      }
			if (this.form.resource == 1) {
				data = {
					email: this.form.email,
					type: this.form.resource,
					customerName: this.form.customerName,
					amount: this.acc(this.form.money,100),
					remark: this.form.remark
				};
			} else if (this.form.resource == 2) {
				if (this.form.tin == '') return this.$message.warning('纳税人识别号不能为空！');
				data = {
					email: this.form.email,
					type: this.form.resource,
					amount:this.acc(this.form.money,100),
					customerName: this.form.customerName,
					tin: this.form.tin,
          billDetailIdLst,
          remark: this.form.remark
				};
			} else {
				if (this.form.tin == '') return this.$message.warning('纳税人识别号不能为空！');
				// if (this.form.contactName == '') return this.$message.warning('接收联系人不能为空！');
				data = {
					email: this.form.email,
					type: this.form.resource,
					amount: this.acc(this.form.money,100),
					customerName: this.form.customerName,
					tin: this.form.tin,
					addr: this.form.addr,
					phone: this.form.phone,
					bankName: this.form.bankName,
					bankAccount: this.form.bankAccount,
          billDetailIdLst,
          contactAddr:this.form.contactAddr,
          contactName:this.form.contactName,
          contactMobile:this.form.contactMobile,
          remark: this.form.remark
				};
			}
			this.loading1 = true
      console.log(data)
      // return
			issue2(data)
				.then(res => {
					console.log(res);
					if (res.data.code == 0) {
            this.loading1 = false
						this.$message({
							type: 'success',
							message: '申请成功！'
						});
						this.form = {
							email: '', //电子邮箱
							customerName: '',
							money: '0',
							tin: '',
							content: '救援服务费', //发票内容
							addr: '',
							phone: '',
							bankName: '',
							bankAccount: '',
              contactAddr:'',
              contactName:'',
              contactMobile:'',
              remark: ''
						};
            this.getData()
					} else if (res.data.code == 102001) {
						this.loading1 = false;
						this.$message.warning('没有权限');
					} else if (res.data.code == 105029) {
						this.loading1 = false;
						this.$message.warning('超额');
					} else {
						this.loading1 = false;
						this.$message.error(res.data.msg || '申请失败，请重试！');
					}
				})
				.catch(err => {
					console.log(err);
					this.loading1 = false;
					var errorMsg = '申请失败，请重试！';
					if(err && err.response && err.response.data && err.response.data.msg){
						errorMsg = err.response.data.msg;
					} else if(err && err.message){
						errorMsg = err.message;
					}
					this.$message.error(errorMsg);
				});

       this.$refs['form'].$el.submit();
		},
		remoteMethod(name) {
			if (name == '') return this.$message.warning('发票抬头不能为空！');
			var data = new FormData();
			data.append('CompanyName', name);
			data.append('Take', 10);
			axios
				.post('http://hk.dajiuxing.com.cn/Tax/QueryCompany', data)
				.then(res => {
					console.log(res);
					this.loading = true;
					if (res.data.Status) {
						this.customerNameList = res.data.Data;
					} else {
						this.customerNameList = [];
					}
				})
				.catch(err => {
					console.log(err);
					this.loading = false;
					var errorMsg = '查询企业信息失败，请重试！';
					if(err && err.response && err.response.data && err.response.data.msg){
						errorMsg = err.response.data.msg;
					} else if(err && err.message){
						errorMsg = err.message;
					}
					this.$message.error(errorMsg);
				});
		},
		getShuihao(obj) {
			var data1 = new FormData();
			this.loading = false;
			this.form.customerName = obj.EnterpriseName;
			data1.append('CompanyIdentity', obj.EnterpriseIdentity);
			axios
				.post('http://hk.dajiuxing.com.cn/Tax/GetCompanyInfo', data1)
				.then(res => {
					console.log(res);
					this.form.tin = res.data.Data.CREDITCODE;
				})
				.catch(err => {
					console.log(err);
					var errorMsg = '获取纳税人识别号失败，请重试！';
					if(err && err.response && err.response.data && err.response.data.msg){
						errorMsg = err.response.data.msg;
					} else if(err && err.message){
						errorMsg = err.message;
					}
					this.$message.error(errorMsg);
				});
		},
		searchData(item) {},
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // 计算子订单金额
      var money = 0;
      val.forEach(item => {
        console.log(item.detail.amount)
        money += Number(item.detail.amount);
      });
      // 合并总订单的选中项来计算总金额
      var totalMoney = money;
      this.orderMultipleSelection.forEach(item => {
        totalMoney += Number(item.bill.realAmount);
      });
      this.form.money = totalMoney / 100;
    },
    /**
     * 获取已选择账单的总数
     * @returns {number} 已选择的账单总数
     */
    /**
     * 获取已选择账单的总数
     * 只统计符合billingState和invoiceStatus条件的账单
     * @returns {number} 已选择的账单总数
     */
    getTotalSelectedCount() {
      var count = this.multipleSelection.length;
      // 总订单选择时，需要计算其下符合条件的子订单数量
      if(this.orderMultipleSelection.length > 0){
        this.orderMultipleSelection.forEach((orderItem) => {
          if(orderItem.details && Array.isArray(orderItem.details) && orderItem.details.length > 0){
            orderItem.details.forEach((detailItem) => {
              // 判断billingState和invoiceStatus，只有符合条件才计数
              if(detailItem && detailItem.id){
                // 检查billingState是否为1、2、3
                var billingStateValid = detailItem.billingState === 1 || detailItem.billingState === 2 || detailItem.billingState === 3;
                // 检查invoiceStatus是否不是1、2（1和2时不计数，其他时候可以计数）
                var invoiceStatusValid = detailItem.invoiceStatus !== 1 && detailItem.invoiceStatus !== 2;
                // 同时满足两个条件才计数
                if(billingStateValid && invoiceStatusValid){
                  count++;
                }
              }
            })
          }
        })
      }
      return count;
    },
    /**
     * 打开账单选择弹框
     */
    openBillDialog() {
      this.centerDialogVisible = true;
      this.value1 = '';
      this.indexPage = 0;
      // 获取 channelId，检查是否需要隐藏子订单tab
      var channelId = localStorage.getItem("channelId");
      if (this.$route.query.fromOrderNew === 'true' || channelId === '2137' || channelId === '2753' || channelId === '2108') {
        this.hideDetailTab = true;
      }
      // 如果隐藏子订单tab，默认选中总订单，否则选中子订单
      if (this.hideDetailTab) {
        this.activeTab = 'order';
        this.orderIndexPage = 0;
        this.orderCurrentPage = 1;
        this.getOrderData();
      } else {
        this.activeTab = 'detail';
        this.getData();
      }
    },
    /**
     * 关闭弹框处理
     */
    handleDialogClose() {
      this.centerDialogVisible = false;
      this.dialogLoading = false; // 关闭弹框时重置loading状态
    },
    /**
     * 确认选择处理
     */
    handleDialogConfirm() {
      // 验证是否选择了账单
      if(this.multipleSelection.length === 0 && this.orderMultipleSelection.length === 0){
        this.$message.warning('请选择账单！');
        return;
      }
      this.centerDialogVisible = false;
    },
    /**
     * 校验纳税人识别号
     * @param {Object} rule - 校验规则对象
     * @param {string} value - 输入的纳税人识别号
     * @param {Function} callback - 回调函数
     */
    validateTin(rule, value, callback) {
      // 统一社会信用代码
      const unifiedReg = /^[A-Z0-9]{18}$/;
      // 身份证类型
      const idCardReg = /^\d{17}[\dXx]\d{2}$/;

      if (!value) {
        callback(new Error('请输入纳税人识别号'));
        return;
      }
      if (value.startsWith('L')) {
        if (
          value.length === 19 &&
          (unifiedReg.test(value.slice(1)) || idCardReg.test(value.slice(1)))
        ) {
          callback();
        } else {
          callback(new Error('临时税号格式错误'));
        }
        return;
      }
      if (unifiedReg.test(value) || idCardReg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的纳税人识别号'));
      }
    }
	}
};
</script>

<style scoped>
input {
	font-size: 16px;
}
p {
	font-size: 18px;
	color: #333;
	font-weight: bold;
	margin: 25px 0;
}
.person {
	width: 1000px;
}
.search {
	color: #00abfa;
	font-weight: bolder;
	border: 0;
	font-size: 16px;
}
.el-select-dropdown__empty {
	display: none;
}
.el-select-dropdown.el-popper {
	display: none;
}
.inpuColor input {
	color: #fea100;
}
.inputBox {
	width: 200px;
	border: 1px solid #ccc;
	margin-top: 10px;
	position: absolute;
	top: 40px;
	left: 0;
	z-index: 100;
	background: white;
	max-height: 200px;
	overflow: auto;
}
.inputBox li {
	cursor: pointer;
	padding-left: 10px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
.inputBox li:hover {
	background: #a0cfff;
}
.overflow{overflow: hidden;}
.overflow .left{float: left;}
.overflow .right{float: right;width: 300px;padding: 25px 0;}
/* 从orderNew页面跳转过来时添加padding */
.from-order-new {
	padding: 100px;
}
</style>
<style>
.inpuColor input {
	color: #fea100;
}
.fenye {
		margin-top: 20px;
		overflow: hidden;
	}
	.fenye .pagination {
		float: right;
	}		
</style>



// WEBPACK FOOTER //
// src/views/financial/settlement/fapiao.vue